var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
/**
 * Validate if a frame rim can be delivered
 * @param sku SKU of the length
 * @param rebateSize Rebate size of the frame rim
 * @returns Delivery validation result (promise)
 */
export function frameDelivery(sku, rebateSize) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get('/api/validation/frame/delivery', {
            params: {
                sku,
                rebateWidth: rebateSize.width,
                rebateLength: rebateSize.length
            }
        });
        return data;
    });
}
/**
 * Validate whether a sheet (cts) can be delivered
 * @param sku SKU of the sheet
 * @param size Size of the sheet
 * @param inFrame Whether the sheet is going in a frame
 * @returns Delivery validation result (promise)
 */
export function sheetDelivery(sku, size, inFrame = false) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get('/api/validation/sheets/delivery', {
            params: {
                sku,
                width: size.width,
                length: size.length,
                isInFrame: inFrame ? 1 : 0
            }
        });
        return data;
    });
}
